import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';

const Donate = ({ data }) => {
  const { title } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;
  useEffect(() => {
    console.log(data);
  }, [data]);
  return (
    <Layout bodyClass="page-services-single">
      <div className="container pb-6 pt-6 pt-md-10 pb-md-10">
        <div className="row justify-content-start">
          <div className="col-12">
            <div className="service service-single">
              <h1 className="title">{title}</h1>
              <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
              <div
                className="text-container p-4"
                style={{
                  background: 'url(/images/donate/clouds.png) 50% no-repeat',
                  color: 'white',
                  backgroundSize: 'cover',
                  display: 'flex',
                  justifyContent: 'space-around'
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <h4>Donate to Hidden Voices at hiddenvoices@sbi or scan the following QR code</h4>
                  <p className="p-large mb-4" style={{ color: 'white' }}>
                    Registered under 80g (AACTH8168EF20231) and 12a
                  </p>
                  <img
                    className="img-fluid"
                    src="/images/donate/qr1.png"
                    style={{ width: 300 }}
                    alt="alternative"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query DonateQuery {
    markdownRemark: markdownRemark(fileAbsolutePath: { regex: "/(donate.md)/" }) {
      html
      frontmatter {
        title
      }
    }
  }
`;

export default Donate;
